import axios from 'axios'

import { RequestQuery, Response, WithFilter } from '@models/apiBase'
import { ID } from '@models/base'
import { InsurancePayorModel } from '@models/insurancePayor'

import { API_URL } from '@/constants/constant'

type RepsonseInsurancePayors = Response<WithFilter<Array<InsurancePayorModel>>>

type PayloadGetInsurancePayorOptionsForQueueNumber = RequestQuery<{
  insurance_id: ID
}>

interface IInsuracePayorsAPI {
  getOptionsForQueueNumber: (payload: PayloadGetInsurancePayorOptionsForQueueNumber) => Promise<RepsonseInsurancePayors>
}

const INSURANCE_PAYORS_URL = `${API_URL}/insurance-payors`

const InsurancePayorsAPI: IInsuracePayorsAPI = {
  getOptionsForQueueNumber: async (payload) => {
    return axios.post(`${INSURANCE_PAYORS_URL}/options/queue-number`, payload).then((r) => r.data)
  },
}

export default InsurancePayorsAPI
